// Module
var code = "<supplier-management supplier-id=\"vm.supplier.id\"></supplier-management>\n";
// Exports
module.exports = code;